import { RNG } from "rot-js";
import { DMap } from "../../../lib/dMap/dMap";
import EntityManager from "../../EntityManager";
import { gameData, getItemsForPosition } from "../../GameManager";
import { ItemTypes } from "../../items/itemsTypes";
import { BasicMap } from "../BasicMap";
import { getRandomInBounds } from "./placement";

export const placeStairs = (rng: typeof RNG, map: BasicMap, dMap: DMap) => {
  for (let fail = 0; fail < 200; fail++) {
    const pos = getRandomInBounds(rng, {
      x: 0,
      y: 0,
      w: map.width,
      h: map.height,
    });
    const dist = dMap.get(pos);
    if (dist && 14 < dist && !getItemsForPosition(pos.x, pos.y).length) {
      EntityManager.createItem(ItemTypes.stairs, pos.x, pos.y);
      return;
    }
  }
};

export const placeXPNode = (rng: typeof RNG, map: BasicMap, dMap: DMap) => {
  for (let fail = 0; fail < 200; fail++) {
    const pos = getRandomInBounds(rng, {
      x: 0,
      y: 0,
      w: map.width,
      h: map.height,
    });
    const dist = dMap.get(pos);
    if (
      dist &&
      gameData.player.pieces.size + 2 < dist &&
      !getItemsForPosition(pos.x, pos.y).length
    ) {
      EntityManager.createItem(ItemTypes.xpNode, pos.x, pos.y);
      return;
    }
  }
};

export const placeFountain = (rng: typeof RNG, map: BasicMap, dMap: DMap) => {
  for (let fail = 0; fail < 200; fail++) {
    const pos = getRandomInBounds(rng, {
      x: 0,
      y: 0,
      w: map.width,
      h: map.height,
    });
    const dist = dMap.get(pos);
    if (
      dist &&
      gameData.player.pieces.size + 2 < dist &&
      !getItemsForPosition(pos.x, pos.y).length
    ) {
      EntityManager.createItem(ItemTypes.refreshSpring, pos.x, pos.y);
      return;
    }
  }
};
